import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { fetchAdminBookingCategories } from "PFApp/booking/services/api";
import { BookingCategory } from "PFCore/types";

import { bookingCategoriesKeys } from "./query_keys";

export type IBookingCategoryResponse = {
  entries: BookingCategory[];
  meta: {
    total: number;
    totalPages: number;
    page: number;
  };
};

export const useAdminBookingCategories = (
  page: number,
  perPage: number = 10000,
  options: Omit<UseQueryOptions<IBookingCategoryResponse>, "queryKey" | "queryFn" | "initialData"> & {
    initialData?: () => undefined;
  } = {}
) =>
  useQuery<IBookingCategoryResponse>(
    bookingCategoriesKeys.ofPage(perPage, page),
    () => fetchAdminBookingCategories(page, perPage) as Promise<IBookingCategoryResponse>,
    {
      retry: false,
      ...options
    }
  );
